import React from 'react';

import { Radio as MuiRadio, RadioProps } from '@mui/material';

import { RadioCheckedIcon, RadioIcon } from './styled';

export const Radio: React.FC<RadioProps> = (props) => {
  return (
    <MuiRadio
      disableRipple
      color="default"
      checkedIcon={<RadioCheckedIcon />}
      icon={<RadioIcon />}
      sx={{ padding: '14px' }}
      {...props}
    />
  );
};
